module.exports = __webpack_public_path__ + "static/media/image-placeholder.a3851ec8.png";